import { defineComponent as _defineComponent } from 'vue'
import { useFollowList } from '@/helpers/composables/useFollowList';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListToggle',
  props: {
    isFollowed: { type: Boolean },
    listId: null,
    listName: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
	isFollowed?: boolean;
	listId?: string;
	listName?: string;
};





const { toggleFollowList } = useFollowList();

async function onFollowToggle() {
	await toggleFollowList({
		listId: props.listId ?? '',
		listName: props.listName ?? '',
		isFollowed: !!props.isFollowed,
	});
	emit('click');
}

return { __sfc: true,props, emit, toggleFollowList, onFollowToggle, faBookmark }
}

})